export const BRAZE_PAGE_NAMES: Record<string, string> = {
    home: 'pll_stats',
  }